import script from "./ProjectMarginsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectMarginsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectMarginsPage.vue?vue&type=style&index=0&id=34e3e182&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34e3e182"]])

export default __exports__